export const environment = {
  production: false,
  version: '1.0.0-#34',
  apiBaseUrl: 'https://apis.dev.auckland.ac.nz/pidgin/v1', // confirm exact path with deployment config
  auth: {
    cognitoAwsRegion: 'ap-southeast-2',
    cognitoClientId: '6v1gesobr1v2a2hl2tlthptvri', //Your consumer's client ID found in /<env>/<project-name>/<project-name>-ACF-id
    cognitoUserPoolId: 'ap-southeast-2_gtuqqgIIq',
    cognitoDomain: 'uoapool-nonprod',
    redirectUri: 'https://pidgin.dev.auckland.ac.nz', //URL for Cognito to redirect to after login. Matching value should be set in your app client configuration on Cognito (manual step)
    logoutUri: 'https://www.auckland.ac.nz/en/about-us/about-the-university/identity-and-access-management/single-sign-on/verify-logout.html', //URL for Cognito to redirect to after logout. Matching value should be set in your app client configuration on Cognito (manual step)
    scopes: 'openid profile https://auth2.auckland.ac.nz/api-pidgin-v1:read https://auth2.auckland.ac.nz/api-pidgin-v1:write', //Scopes which will be included in your access token. Should always include openid & profile + any other API specific scopes required.
    codeChallengeMethod: 'S256',
  },
  privateUrlKeyWords: {
    // default optional to false
    whoNeedBearerToken: [{ url: 'apis.dev.auckland.ac.nz', optional: false }],
  },
  groupManagementUrls: {
    feeders: 'https://groups.test.auckland.ac.nz/grouper/grouperUi/app/UiV2Main.index?operation=UiV2Group.viewGroup&groupId=57c40bac9da6405da5eef72102a28705',
    admins:  'https://groups.test.auckland.ac.nz/grouper/grouperUi/app/UiV2Main.index?operation=UiV2Group.viewGroup&groupId=5a0919fc1de74e528fe4e99cf51827fe',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */